module.exports = __webpack_public_path__ + "assets/503d9c72991f75453e1ae5b2a8ef5c0b.png";